import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import * as actions from "redux/actions/optionOrderActions";
import * as actions_dashboard from "redux/actions/dashboardActions";
import { Translate, I18n } from "react-redux-i18n";
import InputDate from 'components/InputDate';
import { loadListEarning } from 'redux/actions/discoverActions';

function getCloseAt(expire_at) {
    if (expire_at && new Date(expire_at) < new Date())
        return new Date(expire_at).toISOString().split('T')[0];

    return new Date().toISOString().split('T')[0];
}

function toNumber(value, fallback = 0) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
}

function buildValuesFromItem(item, price, userId) {
    return {
        close_price: price || Math.abs(item.close_price) || 0.01,
        open_price: item.open_price ?? 0.01,
        open_trade: item.open_trade,
        side_market: item.market,
        option_id: item.id,
        close_at: getCloseAt(item.expire_at),
        symbol: item.symbol,
        id: userId,
        quantity: item.quantity,
        market: item.market === 'BUY' ? 'STC' : 'BTC',
        strike: item.strike,
        option_kind: item.option_kind,
        quantity_tmp: item.quantity,
        isValid: true,
        errors: {},
    };
}

function calcCloseProceeds(quantity, closePrice) {
    return toNumber(quantity) * toNumber(closePrice) * 100;
}

function calcClosePl({ sideMarket, openPrice, openTrade, quantity, closePrice }) {
    const qty = toNumber(quantity);
    const close = toNumber(closePrice);
    const signedClose = sideMarket === 'SELL' ? -close : close;
    const closeTrade = qty * signedClose * 100;

    if (openTrade != null && openTrade !== '' && Number.isFinite(Number(openTrade))) {
        return Number(openTrade) + closeTrade;
    }

    const open = Number(openPrice);
    if (!Number.isFinite(open)) {
        return null;
    }

    return (open + signedClose) * 100 * qty;
}

function formatMoney(value) {
    if (value == null || !Number.isFinite(value)) {
        return '—';
    }
    return value.toFixed(2);
}
const FormDialog = props => {

    const { item, ...rest } = props;

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        setValues(buildValuesFromItem(item, props.price, props.user_id));
        if (item.sub_order.length > 1) {
            setStrategy({
                ...strategy,
                leg: item.sub_order,
                symbol: item.sub_order.length > 1 && item.sub_order[0].symbol,
            });
            // let leg = item.sub_order;
            // for (let i = 0; i < item.sub_order.length; i++) {
            //     leg[i].close_price= props.price || Math.abs(item.open_price) || 0.01;
            // }
        }
    };

    const handleClose = () => {
        setOpen(false);
        if (typeof props.close === 'function') {
            props.close();
        }
    };

    const [values, setValues] = useState(() => buildValuesFromItem(item, props.price, props.user_id));

    useEffect(() => {
        setValues(buildValuesFromItem(item, props.price, props.user_id));
    }, [item, props.price, props.user_id]);

    const [strategy, setStrategy] = useState({
        symbol: item.sub_order.length > 1 && item.sub_order[0].symbol,
        name: "",
        id: props.user_id,
        share: false,
        leg: item.sub_order
    });

    const validate = (formValues) => {
        const qty = toNumber(formValues.quantity, NaN);
        const maxQty = toNumber(formValues.quantity_tmp, NaN);
        if (!Number.isFinite(qty) || qty <= 0) {
            return { quantity: 'Quantity is empty' };
        }
        if (Number.isFinite(maxQty) && qty > maxQty) {
            return { quantity: 'Quantity is wrong' };
        }
        return null;
    }

    useEffect(() => {
        const errors = validate(values);
        setValues((prev) => ({
            ...prev,
            isValid: !errors,
            errors: errors || {},
        }));
    }, [values.quantity, values.quantity_tmp, values.close_price]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (!name) {
            return;
        }
        setValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        if (item.sub_order.length > 1) {
            await props.updateStrategy(strategy, props.token);
        } else {
            await props.updateItem(values, props.token);
        }

        await props.loadList(props.user_id, props.token);
        props.loadListIndicator(props.user_id, props.token);
        handleClose();
    };

    const handleSaveShare = (event) => {
        if (item.sub_order.length > 1)
            props.updateStrategy({ ...strategy, share: true }, props.token);
        else
            props.updateItem({ ...values, share: true }, props.token);

        handleClose();
    };

    const handleChangeLeg = (i, e) => {
        let leg = strategy.leg;
        if (i === 0 && e.target.name === "close_at") {
            for (let i = 0; i < leg.length; i++) {
                leg[i][e.target.name] = e.target.value;
            }
        } else
            leg[i][e.target.name] = e.target.value;
        setStrategy(strategy => ({
            ...strategy,
            leg: leg
        }));
    }

    return (
        // <div style={{ "display": "inline" }}>
        //     <button className='btn btn-primary btn-sm'
        //         onClick={handleClickOpen}>
        //         <Translate value="close" />
        //     </button>
        //     {open && (
            <div className='dialog '  onClose={handleClose} key={props.key}>
               
                <div className='dialog-content' style={{ "maxWidth": "700px" }}>
                     <div className='dialog-title'> Option Close {item.symbol}</div>
                    <div className='dialog-content-text'>
                        Enter Data Option - Strike {item.strike}
                    </div>
                    {
                        (item.sub_order.length > 1) ?
                            (
                                strategy.leg.map((element, index) => (
                                    <div className="entry-form-grid entry-form-grid--close-option">
                                        <div className="entry-field">
                                            <label htmlFor={`quantity_${index}`}>Quantity</label>
                                            <input
                                                id={`quantity_${index}`}
                                                name="quantity"
                                                required="true"
                                                type="number"
                                                min="1"
                                                value={element.quantity}
                                                onChange={e => handleChangeLeg(index, e)}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor={`option_kind_${index}`}>Option kind</label>
                                            <input
                                                id={`option_kind_${index}`}
                                                name="option_kind"
                                                type="text"
                                                value={element.option_kind}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor={`strike_${index}`}>Strike</label>
                                            <input
                                                id={`strike_${index}`}
                                                name="strike"
                                                type="number"
                                                min="1"
                                                value={element.strike}
                                                onChange={e => handleChangeLeg(index, e)}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor={`market_${index}`}>Kind market</label>
                                            <input
                                                id={`market_${index}`}
                                                name="market"
                                                type="text"
                                                disabled={true}
                                                value={element.market === 'BUY' ? 'STC' : 'BTC'}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor={`close_price_${index}`}>Close price</label>
                                            <input
                                                autoFocus
                                                id={`close_price_${index}`}
                                                name="close_price"
                                                type="number"
                                                min="0.01"
                                                step="0.01"
                                                inputProps={{
                                                    step: 0.01,
                                                }}
                                                value={element.close_price || Math.abs(element.open_price)}
                                                onChange={e => handleChangeLeg(index, e)}
                                            />
                                        </div>
                                        <div className="entry-field" >
                                            <label htmlFor={`close_at_${index}`}>Close date</label>
                                            <InputDate
                                                id={`close_at_${index}`}
                                                name="close_at"
                                                required="true"
                                                label=""
                                                value={element.close_at || new Date().toISOString().split('T')[0]}
                                                onChange={e => handleChangeLeg(index, e)}
                                                min="1900-01-01"
                                                max={new Date().toISOString().split('T')[0]}
                                                disabled={false}
                                            />
                                        </div>
                                    </div>
                                ))
                            )
                            :
                            (
                                <React.Fragment>
                                    <div className="entry-form-grid entry-form-grid--close-option">
                                        <div className="entry-field">
                                            <label htmlFor="quantity">Quantity</label>
                                            <input
                                                id="quantity"
                                                name="quantity"
                                                required="true"
                                                type="number"
                                                min="1"
                                                value={values.quantity}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="option_kind">Option kind</label>
                                            <input
                                                id="option_kind"
                                                name="option_kind"
                                                required="true"
                                                type="text"
                                                value={values.option_kind}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="strike">Strike</label>
                                            <input
                                                id="strike"
                                                name="strike"
                                                type="number"
                                                min="1"
                                                value={values.strike}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="market">Kind market</label>
                                            <input
                                                id="market"
                                                name="market"
                                                type="text"
                                                disabled={true}
                                                value={values.market}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="close_price">Close price</label>
                                            <input
                                                autoFocus
                                                id="close_price"
                                                name="close_price"
                                                type="number"
                                                min="0.01"
                                                step="0.01"
                                                inputProps={{
                                                    step: 0.01,
                                                }}
                                                value={values.close_price}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="entry-field" style={{ minWidth: '180px' }}>
                                            <label htmlFor="close_at">Close date</label>
                                            <InputDate
                                                id="close_at"
                                                name="close_at"
                                                required="true"
                                                label=""
                                                value={values.close_at}
                                                onChange={handleChange}
                                                min="1900-01-01"
                                                max={new Date().toISOString().split('T')[0]}
                                                disabled={false}
                                            />
                                        </div>
                                    </div>
                                    <p className="entry-close-summary">
                                        {formatMoney(calcCloseProceeds(values.quantity, values.close_price))} USD.
                                        {' P/L = '}
                                        {formatMoney(calcClosePl({
                                            sideMarket: values.side_market || item.market,
                                            openPrice: values.open_price,
                                            openTrade: values.open_trade,
                                            quantity: values.quantity,
                                            closePrice: values.close_price,
                                        }))}
                                    </p>
                                </React.Fragment>
                            )
                    }

               
                    <div className='dialog-actions'>
                        <button className='btn btn-secondary'
                        onClick={handleClose}
                            // variant="outlined"
                        ><Translate value="cancel" /></button>
                        <button className='btn btn-primary'
                            onClick={handleSaveShare}
                            // variant="outlined"
                            disabled={!values.isValid}
                        ><Translate value="save_share" /></button>
                        <button className='btn btn-primary'
                            onClick={handleSave}
                            // variant="outlined"
                            disabled={!values.isValid}
                        ><Translate value="save" /></button>
                    </div>
                </div>
            </div>
        //     )}
        // </div >
    );
}

FormDialog.propTypes = {
    item: PropTypes.object
};

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

    };
}
const mapDispatchToProps = dispatch => ({
    updateItem: (params, token) =>
        dispatch(actions.updateItem({ params, token })),
    updateStrategy: (params, token) =>
        dispatch(actions.updateStrategy({ params, token })),
    loadList: (user_id, token) =>
        dispatch(actions.loadList({ user_id, token })),
    //////////////////////////////
    loadListIndicator: (user_id, token) =>
        dispatch(actions_dashboard.loadListIndicator({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);